module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-5.8dc78504.png";